import React, { useState,useEffect } from "react";
import api from "views/auth/Api";
import "../training.css"
import { useParams,Link } from 'react-router-dom';
import { GoPlay } from "react-icons/go";
import { FiEdit } from "react-icons/fi";
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';

const TrainingVoxel = () => {
  const [trainingData , setTrainingData] = useState();
  const [selected , setSelected] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  useEffect(()=>{ 
   api.get(`${API_BASE_URL}training/${id}`)
    .then((response) => { 
      setTrainingData(response.data)
      // setResources(response.data?.resources )
    })
    .catch((error) => {
      console.error('Error fetching card:', error);
    });
  },[id]);
   
  const MyComponent=({ htmlContent }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
}

const scrollToTop = () => {
    window.scrollTo({
      top: 120,
      behavior: 'smooth', // smooth scroll
    });
  };

  return (
    <div className="">
      <div className="field-header justify-between">
        <div className="flex">
         <div className="fieldImg"></div>
          <div className="field-h">
            <h2>{trainingData?.name}</h2>
          </div>
          </div>
          <div className="self-center">
          <Link to={`/admin/training/editdetails/${id}`} className="self-center" ><div className="newChallenge mt-2 w-[167px]">
          <FiEdit className="addImg"/>
              <span>Details</span>
              </div></Link>  
          <Link to={`/admin/training/edit/${id}`} className="self-center" ><div className="newChallenge mt-2 w-[167px]">
          <FiEdit className="addImg"/>
              <span>Resources</span>
              </div></Link>
              <Link to={`/admin/training/editquiz/${id}`} ><div className="newChallenge mt-2 w-[167px]">
                           <FiEdit className="addImg"/>
                           <span>MCQ Quiz </span>
                         </div></Link> </div>

      </div>
      <div style={{ flex: 1 }}>
        {selected ? (
            <div className="videoFrame">
            <h3 className="videoName">{selected.title}</h3>
            <iframe
              key={selected.id}
              src={selected.url}
              style={{ border: 0, width: "95%", height: "700px", borderRadius: "25px", marginBottom: "20px", alignItems: "center" }}
              allowFullScreen
              allow="encrypted-media"
              title="VdoCipher Video"> </iframe>
            {loading && <div>Saving progress...</div>}
           {/* {!selected.completed ? <button className="markComplete"
            onClick={() => {handleComplete(selected.id)
              scrollToComplete();
            }}>Mark as Complete 
            <IoCheckmarkDoneCircleOutline className="doneImgHover"/></button> : null} */}
          </div>
        ) : (
          <div style={{marginBottom: "20px"}}>
          </div>
        )}
      </div>
        {/* Course Overview */}
        <div className="courseLayout">
            <div className="courseOverview">
          <div className="trainingCover" style={{backgroundImage:`url(${FILES_URL}${trainingData?.cover?.url})`}}></div>
                <h4>Course Overview</h4>
                <p> 
                   <MyComponent htmlContent={trainingData?.overview}/>    
                </p>
            </div>
            <div className="courseCards">
              {trainingData?.resources.map(video =>
            <div className="course-view" key={video.id}
            style={{ cursor: 'pointer'}}
            onClick={() => {setSelected(video)
            scrollToTop(video);
            }}>
            <div className="playImg"></div>
            {/* {video.order} */}
            <p>{video.title} </p> 
              <GoPlay className="doneImg" style={{ color: "#573995" }}/>    
              </div>
          )}
          </div>
        </div>
    </div>
  );
};

export default TrainingVoxel;
